import { extensionFromName } from '@/components/AiAskBar/attachmentMetaExtension.js'
import { getArtifactDownloadFileName, getArtifactExportText } from './getArtifactExportText.js'

/**
 * @param {import('./documentPreviewTypes.js').GeneratedArtifactPreview} artifact
 * @returns {boolean}
 */
export function downloadArtifactExport(artifact) {
  const exportText = getArtifactExportText(artifact)
  if (!exportText.trim()) return false

  const fileName = getArtifactDownloadFileName(artifact.fileName, artifact.kind)
  const ext = extensionFromName(fileName)
  const mimeType =
    ext === 'zip'
      ? 'application/zip'
      : artifact.kind === 'html'
        ? 'text/html;charset=utf-8'
        : 'text/plain;charset=utf-8'

  const blob = new Blob([exportText], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
  return true
}
